// extracted by mini-css-extract-plugin
export const root = "large-image-module--root--z4UBR";